import { useState } from "react";
import { Moon, Sun, Menu, X, Linkedin, Download } from "lucide-react";
import { profile } from "@/data/profile";

const links = [
  { id: "about", label: "About" },
  { id: "experience", label: "Experience" },
  { id: "education", label: "Education" },
  { id: "skills", label: "Skills" },
  { id: "leadership", label: "Leadership" },
  { id: "honors", label: "Honors" },
  { id: "gallery", label: "Gallery" },
  { id: "contact", label: "Connect" },
];

export const Navbar = ({ dark, onToggleTheme }) => {
  const [open, setOpen] = useState(false);

  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    setOpen(false);
  };

  return (
    <header className="navbar" data-testid="main-navigation-bar">
      <div className="navbar-inner">
        <button className="navbar-brand" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })} data-testid="nav-brand">
          AB<span className="brand-dot">.</span>
        </button>
        <nav className="navbar-links">
          {links.map((l) => (
            <button key={l.id} className="nav-link" onClick={() => scrollTo(l.id)} data-testid={`nav-link-${l.id}`}>
              {l.label}
            </button>
          ))}
        </nav>
        <div className="navbar-actions">
          <button className="icon-btn" onClick={onToggleTheme} data-testid="theme-toggle-button" aria-label="Toggle theme">
            {dark ? <Sun size={17} /> : <Moon size={17} />}
          </button>
          <a href="/Arjan-Bajwa-Resume.pdf" download="Arjan-Bajwa-Resume.pdf" className="resume-btn" data-testid="resume-download-button">
            <Download size={15} /> Resume
          </a>
          <a href={profile.linkedin} target="_blank" rel="noopener noreferrer" className="linkedin-btn" data-testid="linkedin-profile-cta">
            <Linkedin size={15} /> LinkedIn
          </a>
          <button className="icon-btn mobile-only" onClick={() => setOpen(!open)} data-testid="mobile-menu-toggle" aria-label="Menu">
            {open ? <X size={18} /> : <Menu size={18} />}
          </button>
        </div>
      </div>
      {open && (
        <div className="mobile-menu" data-testid="mobile-menu">
          {links.map((l) => (
            <button key={l.id} className="mobile-link" onClick={() => scrollTo(l.id)} data-testid={`mobile-nav-link-${l.id}`}>
              {l.label}
            </button>
          ))}
        </div>
      )}
    </header>
  );
};
